// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Los7","checkboxCol":"Table_checkboxCol__1LHRe","emailCol":"Table_emailCol__1wTle","actionCol":"Table_actionCol__X3tyD"};